<template>
  <basic-card padding hideHeader :hasMore="showMore">
    <avue-crud
      :key="tableKey"
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      v-model="form"
      v-model:search="search"
      :permission="permissionObj"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
      @tree-load="treeLoad"
    >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
          <div>
            <!-- <comp-button
              type="normal"
              @click="toggleShowMore()"
              >{{ Lang.btn.more }}
            </comp-button> -->
          </div>
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            type="delete"
            v-if="permissionObj.delete"
            plain
            @click="handleDelete"
            >{{ Lang.btn.delete }}
          </comp-button>
          <comp-button
              type="primary"
              icon="icon-add"
              @click.stop="handleAdd()"
              v-if="permissionObj.add"
              >{{ Lang.btn.addNew }}
            </comp-button>
        </div>
      </template>
      <!-- 操作菜单按钮 -->
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" @click="handleView(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="edit" @click="handleEdit(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="add" @click="handleAddSub(scope.row)" :text="Lang.btn.addSub" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>
      <template #name="{ row }">
        <i :class="row.source" style="margin-right: 5px" />
        <span>{{ row.name }}</span>
      </template>
      <template #source="{ row }">
        <div style="text-align: center">
          <i :class="row.source" />
        </div>
      </template>
      <template #i18ns-form="{ row }">
        <div class="global-i18n-fields">
          <el-form-item
            span="12"
            gutter="12"
            class="form-item"
            v-for="(item, i) in i18nOptoins"
            :label="Lang.label.name + ' ' + item.i18nLanguage"
            :prop="'i18ns.' + i + '.i18nValue'"
            :rules="item.i18nLanguage === 'en-US' ? [{ required: true, message: Lang.tips.plzInput + ' ' + item.i18nLanguage, trigger: 'blur' }] : []"
            labelPosition="top">
            <el-input
              class="el-input"
              v-model="form.i18ns[i].i18nValue"
              :placeholder="Lang.tips.plzInput + ' ' + item.i18nLanguage"
              :key="i"
              />
          </el-form-item>
        </div>
      </template>

    </avue-crud>
  </basic-card>
</template>

<script>
import { getLazyList, getList, remove, update, add, getMenu } from '@/api/system/menu';
import { mapGetters } from 'vuex';
import iconList from '@/config/iconList';
import func from '@/utils/func';
import { getMenuTree } from '@/api/system/menu';
import { filterDollarKeys } from '@/utils/util';
import { i18nOptoins, generateI18nOptoins } from '@/lang/lang';

export default {
  data() {
    return {
      tableKey: 0,
      i18nOptoins: i18nOptoins,
      form: {},
      query: {},
      search: {},
      loading: true,
      showMore: true,
      selectionList: [],
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 84,
        lazy: false,
        tip: false,
        simplePage: true,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 4,
        searchMenuPosition: 'right',
        searchLabelWidth: 'auto',
        searchGutter: 12,
        gutter: 12,
        dialogWidth: '60%',
        tree: true,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: true,
        emptyBtn: false,
        searchBtn: false,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        menuWidth: 146, // 操作列宽
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        dialogClickModal: false,
        dialogType: 'dialog',
        labelWidth: 'auto',
        labelPosition: 'top',
        searchLabelPosition: 'left',
        dialogCustomClass: 'global-dialog',
        searchLabelSuffix: ' ',
        labelSuffix: ' ',
        column: [
        {
            label: this.Lang.label.menuType,
            prop: 'category',
            type: 'radio',
            dicData: [
              {
                label: this.Lang.label.menu,
                value: 1,
              },
              {
                label: this.Lang.label.button,
                value: 2,
              },
            ],
            hide: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectMenuType,
                trigger: 'blur',
              },
            ],
          },

          {
            label: this.Lang.label.ifCache,
            prop: 'isOpen',
            type: 'radio',
            hide: true,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 1,
              },
              {
                label: this.Lang.label.yes,
                value: 2,
              },
            ],
            value: 1,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzUseOpenInNewWindow,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.menuName'),
            prop: 'i18nValue',
            search: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputMenuName,
                trigger: 'blur',
              },
            ],
          },
          // {
          //   label: this.Lang.label.enName,
          //   prop: 'enName',
          //   search: true,
          //   editDisplay: false,
          //   addDisplay: false,
          //   viewDisplay: false,
          //   rules: [
          //     {
          //       required: true,
          //       message: this.Lang.tips.plzInputMenuEnName,
          //       trigger: 'blur',
          //     },
          //   ],
          // },
          {
            prop: 'i18ns',
            search: false,
            slot: true,
            editDisplay: true,
            addDisplay: true,
            viewDisplay: true,
            hide: true,
            span: 24,
          },
          {
            label: this.$t('theader.rutingAddress'),
            prop: 'path',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputRouteAddress,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.preMenu,
            prop: 'parentId',
            type: 'tree',
            dicData: [],
            hide: true,
            addDisabled: false,
            props: {
              label: 'title',
            },
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzSelectSuperiorMenu,
                trigger: 'click',
              },
            ],
          },
          {
            label: this.$t('theader.menuIcon'),
            prop: 'source',
            type: 'icon',
            slot: true,
            iconList: iconList,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputMenuIcon,
                trigger: 'click',
              },
            ],
          },
          
          {
            label: this.Lang.label.menuNum,
            prop: 'code',
            search: true,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=permissionButton',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputMenuNum,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.menuAliases'),
            prop: 'alias',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputMenuAliaName,
                trigger: 'blur',
              },
            ],
          },
          
          {
            label: this.$t('theader.menuSorting'),
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputMenuSort,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.menuRemark,
            prop: 'remark',
            type: 'textarea',
            span: 24,
            minRows: 2,
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'form.category'() {
      const category = func.toInt(this.form.category);
      this.$refs.crud.option.column.filter(item => {
        if (item.prop === 'path') {
          item.rules[0].required = category === 1;
        }
        if (item.prop === 'code') {
          item.type = category === 1 ? 'input' : 'select';
        }
        if (item.prop === 'source') {
          item.rules[0].required = category === 1;
        }
        if (item.prop === 'isOpen') {
          item.disabled = category === 2;
        }
      });
    },
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('菜单页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search)
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    initData() {
      getMenuTree().then(res => {
        const column = this.findObject(this.option.column, 'parentId');
        column.dicData = res.data.data;
      });
    },
    handleAddSub(row) {
      this.parentId = row.id;
      const column = this.findObject(this.option.column, 'parentId');
      column.value = row.id;
      column.addDisabled = true;
      this.$refs.crud.rowAdd();
    },
    rowSave(row, done, loading) {
      add(row).then(
        res => {
          // 获取新增数据的相关字段
          const data = res.data.data;
          row.id = data.id;
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.onLoad(this.page);
          // 数据回调进行刷新
          done(row);
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          // 数据回调进行刷新
          done(row);
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row, index, done) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          // 数据回调进行刷新
          done(row);
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          // 刷新表格数据并重载
          this.data = [];
          this.parentId = 0;
          this.$refs.crud.refreshTable();
          this.$refs.crud.toggleSelection();
          // 表格数据重载
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.parentId = 0;
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.parentId = '';
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeOpen(done, type) {
      if (['add', 'edit'].includes(type)) {
        this.initData();
      }
      if (['edit', 'view'].includes(type)) {
        getMenu(this.form.id).then(res => {
          this.form = Object.assign(res.data.data, {
            hasChildren: this.form.hasChildren,
          });
          if (!this.form.i18ns.length) {
            this.i18nOptoins = this.i18nOptoins.map(item => {
              return {
                i18nField: 'name',
                i18nLanguage: item.i18nLanguage,
                i18nValue:  '',
              };
            });
          } else {
            this.i18nOptoins = this.form.i18ns?.map(item => {
              return {
                i18nField: item.i18nField,
                i18nLanguage: item.i18nLanguage,
                i18nValue:  item.i18nValue || '',
              };
            });
          }
          this.form.i18ns = this.i18nOptoins;
        });
      }
      if (type === 'add') {
        const options = generateI18nOptoins();
        this.i18nOptoins = options.map(item => {
          return {
            i18nField: 'name',
            i18nLanguage: item.i18nLanguage,
            i18nValue: '',
          };
        });
        this.form.i18ns = this.i18nOptoins;
      }
      done();
    },
    beforeClose(done) {
      this.parentId = '';
      const column = this.findObject(this.option.column, 'parentId');
      column.value = '';
      column.addDisabled = false;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      const param =  {
        ...params,
        size: this.page.pageSize,
        current: this.page.currentPage,
        ...this.query,
        // parentId: this.parentId,
      }
      getList(param).then(res => {
        this.data = res.data.data;
        this.loading = false;
        this.selectionClear();
      });
    },
    treeLoad(tree, treeNode, resolve) {
      const parentId = tree.id;
      getList(parentId).then(res => {
        resolve(res.data.data);
      });
    },
  },
};
</script>

<style></style>
